export default "__VITE_ASSET__e86b7b3b__"